import React from "react";
import "../../../css/ValuesSection.css";
import { ReactComponent as IntegrityIcon } from "../../../assets/icons/1.svg";
import { ReactComponent as SelflessnessIcon } from "../../../assets/icons/2.svg";
import { ReactComponent as ExcellenceIcon } from "../../../assets/icons/3.svg";

const ValuesSection = () => (
  <section className="values-section">
    <div className="nav-bold secondary">MISSION AND VALUES</div>
    <h2 className="values-heading">
      What we <span style={{ fontStyle: "italic" }}>Stand for</span>
    </h2>
    <div className="values-row">
      <div className="values-item">
        <div className="icon-circle">
          <IntegrityIcon className="values-icon" />
        </div>
        <div className="nav-bold secondary">INTEGRITY</div>
        <div className="content">We tell you what you need to hear.</div>
      </div>

      <div className="divider" />

      <div className="values-item">
        <div className="icon-circle">
          <SelflessnessIcon className="values-icon" />
        </div>
        <div className="nav-bold secondary">SELFLESSNESS</div>
        <div className="content">Your goals are our only agenda.</div>
      </div>

      <div className="divider" />

      <div className="values-item">
        <div className="icon-circle">
          <ExcellenceIcon className="values-icon" />
        </div>
        <div className="nav-bold secondary">EXCELLENCE</div>
        <div className="content">A standard that goes beyond regulation.</div>
      </div>
    </div>
 
  </section>
);

export default ValuesSection;
